import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon, DatabaseIcon } from 'lucide-react';
import { useClient } from './ClientContext';
interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SuccessModal({
  isOpen,
  onClose
}: SuccessModalProps) {
  const {
    clientName
  } = useClient();
  const firstName = clientName.split(' ')[0] || 'Rakesh';
  return <AnimatePresence data-id="element-212">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-213">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-navy/60 backdrop-blur-sm" data-id="element-214" />

          <motion.div initial={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} className="relative w-full max-w-md bg-surface rounded-2xl shadow-2xl p-8 text-center overflow-hidden" data-id="element-215">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-navy transition-colors" data-id="element-216">
              <XIcon className="w-5 h-5" data-id="element-217" />
            </button>

            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-218">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring'
          }} data-id="element-219">
                <CheckIcon className="w-8 h-8 text-green-600" data-id="element-220" />
              </motion.div>
            </div>

            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-221">
              Proposal Signed!
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-222">
              Thank you, {firstName}. Your proposal has been submitted
              successfully. A confirmation copy has been prepared for the team.
            </p>

            {/* Notion integration confirmation */}
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl mb-6 text-left" data-id="element-223">
              <div className="w-10 h-10 bg-navy/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-224">
                <DatabaseIcon className="w-5 h-5 text-navy" data-id="element-225" />
              </div>
              <p className="text-sm text-gray-600" data-id="element-226">
                A new page has been created in the project database. We're
                excited to start this journey with you and we'll be in touch
                shortly.
              </p>
            </motion.div>

            <button onClick={onClose} className="w-full py-3 px-6 bg-navy text-white font-medium rounded-lg hover:bg-navy-light transition-colors" data-id="element-227">
              Close
            </button>
          </motion.div>
        </div>}
    </AnimatePresence>;
}